<template lang="pug">
#modal-promo01.modal.fade(tabindex='-1' aria-hidden='true')
  .modal-dialog.modal-lg.modal-dialog-centered.modal-dialog-scrollable
    .modal-content
      template(v-if="promoSelected.length > 0")
        template(v-if="getLanguage==='zh'")
          .modal-header
            h5.modal-title(v-html="promoSelected[0].cn_title")
            button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
              i.fa-solid.fa-xmark
          .modal-body
            .text-center
              img(:src='imgUrl+promoSelected[0].cn_image_url')
            .py-3.promo-content(v-html="promoSelected[0].cn_body")
        template(v-else-if="getLanguage==='my'")
          .modal-header
            h5.modal-title(v-html="promoSelected[0].mys_title")
            button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
              i.fa-solid.fa-xmark
          .modal-body
            .text-center
              img(:src='imgUrl+promoSelected[0].mys_image_url')
            .py-3.promo-content(v-html="promoSelected[0].mys_body")
        template(v-else)
          .modal-header
            h5.modal-title(v-html="promoSelected[0].en_title")
            button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
              i.fa-solid.fa-xmark
          .modal-body
            .text-center
              img(:src='imgUrl+promoSelected[0].en_image_url')
            .py-3.promo-content(v-html="promoSelected[0].en_body")
</template>
<script>
import config from "@/config";
export default {
  props: {
    target: { //to get full promo list
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      promoList: [],
			promoSelected: [],
      loading:false,
			imgUrl: config.imageUrl,
    }
  },
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
	},
  created(){
    this.getPromoBanner()
  },
  mounted(){
  },
  methods:{
    getPromoBanner(){
			this.$store
        .dispatch("user/getPromoBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.promoList = response.data
            if(this.target){
              this.$emit("getList", this.promoList)
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
		},
    showPromo(id, option){
      this.promoSelected = this.promoList.filter(item => item.id === id)
			$("#modal-promo01").modal("show")
    },
    toLeaderboard(){
      this.$router.push({
        name:"reviews",
        params:{
          "leaderboard": true
        }
      }).catch(error =>{})
      $('#modal-promo16').modal("hide")
    }
  }
}
</script>